export const OfferStepNames = {
	MAIN_DATA: "Podstawowe informacje",
	STATS: "Statystyka",
	DATES: "Ramy czasowe",
	ACTIONS: "Działania programowe",
	COSTS: "Koszty",
	COSTS_SHARE: "Podział kosztów",
	COSTS_SUMMARY: "Podsumowanie kosztów",
	SEND_OFFER: "Składanie oferty",
};
